export default __webpack_public_path__ + "static/cma-69c31f3d7f63a7f04903c7e365c33c97.jpg";